module.exports = __webpack_public_path__ + "static/ma-8-9fcb6e64fb5788f13bd390cbc80ad53b.png";